import Swiper from 'swiper';

const swiperEl = document.getElementById('swiperCounter');

if (swiperEl) {

  const slideCount = swiperEl.innerHTML;

  const swiper = new Swiper('.slider-container', {
    slidesPerView: 1,

    loop: true,

    pagination: {
      el: '.slider-pagination',
      clickable: true,
    },

    autoplay: {
      delay: 3500,
      disableOnInteraction: true
    },

    speed: 1000,
    spaceBetween: 30,

    breakpoints: {
      // when window width is >= 320px
      648: {
        slidesPerView: slideCount < 2 ? slideCount : 2,
      },
      // when window width is >= 480px
      1024: {
        slidesPerView: slideCount < 3 ? slideCount : 3,
      },
      // when window width is >= 640px
      1280: {
        slidesPerView: slideCount < 4 ? slideCount : 4,
      }
    },

  });

}
